import {
  ClientInformationDrawerBodyContentConnected as ClientInformationDrawerBodyContent,
  ClientActivityContentLocation,
} from "@grow-therapy-team/seedling-components";
import { useAtomValue } from "jotai";
import { ClientInformationTabWrapper as ClientInformationTab } from "./ClientInformationTab";

import {
  isInSessionWithSelectedClientAtom,
  providerShortIdAtom,
  selectedClientInfoAtom,
  selectedClientUserShortIdAtom,
} from "../state";
import { UpcomingClientAppointmentsTabWrapper as UpcomingClientAppointmentsTab } from "./client-appointments-tab/UpcomingClientAppointmentsTab";
import { TreatmentTabWrapper as TreatmentTab } from "./treatment-tab/TreatmentTab";

export function ClientInformationDrawerBodyContentWrapper({
  isEmpty,
}: {
  isEmpty: boolean;
}) {
  const patientShortId =
    useAtomValue(selectedClientInfoAtom)?.patientShortId ?? "";
  const isInSession = useAtomValue(isInSessionWithSelectedClientAtom);
  const providerShortId = useAtomValue(providerShortIdAtom);
  const coachTabLocation = isInSession
    ? ClientActivityContentLocation.InSessionTelehealth
    : ClientActivityContentLocation.OutOfSessionTelehealth;
  const clientUserShortId = useAtomValue(selectedClientUserShortIdAtom) ?? "";

  return (
    <ClientInformationDrawerBodyContent
      location={coachTabLocation}
      patientShortId={patientShortId}
      clientUserShortId={clientUserShortId}
      clientInformationTabContent={<ClientInformationTab isEmpty={isEmpty} />}
      treatmentTabContent={<TreatmentTab />}
      appointmentTabContent={<UpcomingClientAppointmentsTab />}
      providerShortId={providerShortId ?? ""}
    />
  );
}
